<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { validateNumber, validateCurp } from "@/helpers/utils.js";
import { todoMethods, todoComputed } from "@/state/helpers";
import * as XLSX from 'xlsx'
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default {
  page: {
    title: "Punto de venta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      label: "",
      title: "Punto de venta",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Punto de venta",
          active: true,
        },
      ],
      tarjeta:{
        folio:""
      },
      folio: "",
      descuento: "",
      mujer: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
      },
      objeto: {
        precio_regular: "",
        total_descuento: "",
        id_tarjeta: "",
      },
      datosExcel: []
    };
  },

  computed: {
      ...todoComputed,
      descuentoTotal() {
        if(this.objeto.precio_regular != "") return this.objeto.precio_regular - this.descuento >= 0 ? this.objeto.precio_regular - this.descuento : 0;
        else return "";
      },
      nombreCompleto() {
        return this.mujer.nombre + " " + this.mujer.apellido_paterno + " " + this.mujer.apellido_materno;
      }
    },

    mounted() {
      this.fetchTodos();
    },

    methods: {
      ...todoMethods,

      // function to reset the form
      resetForm() {
        this.folio = "";
        this.mujer = {
          nombre: "",
          apellido_paterno: "",
          apellido_materno: "",
        };
        this.objeto = {
          precio_regular: "",
          total_descuento: "",
          descuento: ""
        };
      },

      // method that validate keypress only numbers
      validateNumber(event, value, max) {
        if (value) {
          if (value.toString().length + 1 > max) {
            event.preventDefault();
          } else validateNumber(event);
        } else {
          validateNumber(event);
        }
      },
      validateCurp(event, value, max) {
        if (value) {
          if (value.length + 1 > max) {
            event.preventDefault();
          } else validateCurp(event);
        } else {
          validateCurp(event);
        }
      },

      // METODO PARA OBTENER LAS TARJETAS
      // getTarjetas() {
      //   axios.get("https://jpa-heroku-api.herokuapp.com/app/tarjetas?request_type=lite").then((res) => {
      //     const { response = "", data = [] } = res.data;
      //     if (response === true) {
      //       const array = [];
      //       data.forEach((t) => {
      //         array.push({ id_tarjeta: t.id_tarjeta, folio: t.folio});
      //       });
      //       this.tarjetas = array;
      //     }
      //   });
      // },

      // METODO PARA OBTENER DATOS DEL ARCHIVO IMPORTADO
      async selectSpreadSheetFile(e) {
        console.log(e);
        this.datosExcel = [];
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          workbook.SheetNames.forEach((sheetName) => {
            var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
            var json_object = JSON.stringify(XL_row_object);
            this.datosExcel.push(JSON.parse(json_object));
          })
          if(this.datosExcel[0].length > 0) {
            let error = false;
            this.datosExcel[0].forEach((dato) => {
              const keys = Object.keys(dato);
              if(keys.length != 3) {
                this.datosExcel = [];
                this.$swal("Error", "El archivo no tiene el formato correcto", "error");
              } else {
                if(keys[0] != 'folio_tarjeta' || keys[1] != 'precio_regular' || keys[2] != 'precio_descuento') {
                  this.datosExcel = [];
                  this.$swal("Error", "El archivo no tiene el formato correcto", "error");
                  error = true;
                }
              }
            })
            if(!error) this.submitVentasMultiple();
          } else this.$swal("Error", "El archivo no contiene la información requerida", "error");
        };
        reader.readAsBinaryString(file);
      },



      // METODO PARA VALIDAR FOLIO
      checkFolioValid() {
        if (this.folio) {
          // check if folio is in the tarjetas array
          // const tarjeta = this.tarjetas.find((t) => t.folio === this.folio);
          // if(!tarjeta) {
          //   this.$swal("Aviso", "El folio ingresado no existe entre las tarjetas disponibles","warning");
          //   return;
          // }
          axios.get("/mujeres?folio=" + this.folio).then((res) => {
            const { response = "" ,data={}} = res.data;
            if (response === true) {
              const {id_tarjeta} = data;
              this.objeto.id_tarjeta = id_tarjeta;
              this.mujer = res.data.data
            }else{
              this.objeto.id_tarjeta = 0;
            }
          }).catch((err) => {
            console.log(err)
            // this.$swal("Aviso", "No se ha encontrado ninguna Mujer relacionada con la tarjeta.","warning");
            this.objeto.id_tarjeta = 0;
          });
        } else this.$swal("Aviso", "Favor de seleccionar un folio de tarjeta.","warning");
      },

      async submitVentasMultiple() {
        if(this.datosExcel[0].length > 0) {
          this.isLoading = true;
          this.datosExcel[0].map(async (dato) => {
            // const tarjeta = this.tarjetas.find((t) => t.folio === dato.folio_tarjeta);
            // if(!tarjeta) {
            //   this.$swal("Aviso", `El folio ${dato.folio_tarjeta} no existe entre las tarjetas disponibles`,"warning");
            //   return;
            // }
            axios.get("/mujeres?folio=" + dato.folio_tarjeta).then((res) => {
              const { response = "" ,data={}} = res.data;
              if (response === true) {
                const {id_tarjeta="", id_usuario=""} = data;
                this.mujer = res.data.data
                console.log(this.mujer);

                const payload = {
                  id_tarjeta: id_tarjeta,
                  precio_regular: dato.precio_regular,
                  total_descuento: dato.precio_descuento,
                  id_usuario: id_usuario
                }
                console.log(payload);
                axios.post("/ventas", payload).then((res) => {
                  console.log(res.data);
                }).catch((err) => {
                  console.log(err)
                  this.$swal("Error", `No se ha podido registrar la venta con folio: ${dato.folio_tarjeta}`, "error");
                });
                this.isLoading = false;
                this.$swal("Exito", "El archivo se ha cargado correctamente", "success");
              }
            }).catch((err) => {
              console.log(err)
               this.$swal("Aviso", "No se ha encontrado ninguna Mujer relacionada con la tarjeta.","warning");
            });
          })
        } else this.$swal("Aviso", "No se ha cargado ningun archivo.","warning");
      },

      handleSubmit() {
        if(this.objeto.precio_regular) {
          this.descuento == "" ? this.descuento = 0 : this.descuento;
          this.objeto.total_descuento = this.descuentoTotal;
          this.objeto.id_usuario = this.mujer.id_usuario;
          const payload = JSON.stringify(this.objeto);
          axios.post("/ventas", payload)
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal("Registro", "Resgitro creado correctamente", "success");
                this.resetForm();
              } else {
                this.$swal("Alerta", "No se pudo crear", "warning");
              }
            })
            .catch((error) => {
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        } else this.$swal("Aviso", "Favor de seleccionar un folio de tarjeta y escribir precio regular.","warning");
      },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title">Nuevo registro de venta</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <div class="d-flex justify-content-end gap-3">
                  <label class="image-file-upload v-btn v-btn--has-bg v-size--default azul">
                    <input 
                      type="file"  
                      id="button-import-ventas" 
                      accept=".xlsx, .xls, .csv"
                      @change="selectSpreadSheetFile"
                      ref="myFiles"
                    />
                    Importar Ventas
                  </label>
                  <v-btn
                    depressed
                    class="verde"
                    type="button"
                    id="button-addon2"
                    @click="resetForm()"
                  >
                    Nuevo Registro
                  </v-btn>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-sm-6 col-md-6">
                  <b>
                    <label class="form-check-label">Numero de Tarjeta</label>
                  </b>
                  <div class="mb-4">
                    <b-form-input
                      id="folio"
                      v-model="folio"
                      placeholder="Escanea o escribe el número de tarjeta aqui"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-2 col-md-2" style="margin-top: auto">
                  <div class="mb-4">
                    <v-btn
                      depressed
                      class="verde"
                      type="button"
                      id="button-addon2"
                      @click="checkFolioValid()"
                    >
                      Buscar
                    </v-btn>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-sm-7 col-md-7">
                  <b>
                    <label class="form-check-label">Nombre de la Mujer</label>
                  </b>
                  <div class="mb-4">
                    <b-form-input
                      id="nombreMujer"
                      disabled
                      v-model="mujer.nombre"
                      placeholder="Nombre Completo de la Mujer"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-sm-6 col-md-6">
                  <b>
                    <label class="form-check-label"
                      >Total (Precio regular)</label
                    >
                  </b>
                  <div class="mb-4">
                    <b-form-input
                      id="precioRegular"
                      placeholder="$00.00"
                      v-model="objeto.precio_regular"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <b>
                    <label class="form-check-label"
                      >Total (Despues del descuento)</label
                    >
                  </b>
                  <div class="mb-4">
                    <b-form-input
                      id="precioDescuento"
                      placeholder="$00.00"
                      v-model="descuento"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-sm-2 col-md-2" style="margin-top: 10px">
                  <b>
                    <label class="form-check-label">Descuento Total</label>
                  </b>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="mb-4">
                    <b-form-input
                      id="totalDescuento"
                      disabled
                      placeholder="$00.00"
                      v-model="descuentoTotal"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-sm-12 col-md-1">
                  <button
                    class="btn btn-success verde"
                    type="button"
                    id="inputGroupFileAddon03"
                    @click="handleSubmit()"
                  >
                    Guardar
                  </button>
                </div>
                <div class="col-sm-12 col-md-1">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    id="inputGroupFileAddon03"
                    @click="resetForm()"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$blue: #007bff;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.verde {
  background-color: $active !important;
  color: white !important;
}

.azul {
  background-color: $blue !important;
  color: white !important;
}

.image-file-upload {
  input[type="file"] { display: none; }
  background-color: var(--color-light);
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: $w;
  height: $h;
  border-radius: 100px;

  .circle {
    display: flex;
    align-items: center;
    width: 100%;
    height: $h - 1;
    border-radius: 100px;
    background-color: $default;

    & > span {
      font-size: $size;
      color: $text;
      padding-left: $h + -6;
    }

    &::before {
      position: absolute;
      content: "";
      height: $circle;
      width: $circle;
      left: 1px;
      top: 1px;
      border-radius: 100px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &:hover {
      background-color: lighten($default, 20);

      & > span {
        color: $text-hover;
      }
    }
  }

  .circle-on {
    background-color: $active;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $active solid;

      &::before {
        background-color: $active;
      }

      & > span {
        color: $active;
      }
    }
  }

  .circle-off {
    background-color: $inactive;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $inactive solid;

      &::before {
        background-color: $inactive;
      }

      & > span {
        color: $inactive;
      }
    }
  }

  & input {
    display: none;

    &:checked + .circle:before {
      -webkit-transform: translateX($toggle-dis);
      -ms-transform: translateX($toggle-dis);
      transform: translateX($toggle-dis);
    }
  }
}
</style>